import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	wrapper: {
		borderRadius: token('radius.large', '3px'),
		width: '360px',
		position: 'relative',
		overflow: 'hidden',
	},
	header: {
		height: '50px',
		width: '100%',
		borderTopLeftRadius: token('radius.large', '3px'),
		borderTopRightRadius: token('radius.large', '3px'),
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		paddingBlock: token('space.300'),
		paddingInline: token('space.300'),
		minHeight: '150px',
	},
	spinner: {
		textAlign: 'center',
		marginTop: token('space.500'),
		marginBottom: token('space.500'),
	},
});

/**
 * CardLoading component to display a loading state while team information is being fetched.
 */
function CardLoading() {
	return (
		<Box
			xcss={cx(styles.wrapper)}
			backgroundColor="elevation.surface.overlay"
			testId="team-profilecard"
		>
			<Box xcss={cx(styles.header)} backgroundColor="color.background.neutral" />
			<Box xcss={cx(styles.content)}>
				<Box xcss={cx(styles.spinner)} testId="team-profilecard-spinner">
					<Spinner />
				</Box>
			</Box>
		</Box>
	);
}

export { CardLoading };
